<template>
  <div>
    <file-uploader :compMode="compMode" entite="Property"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i>
        <span
          v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
        >{{ $t('project.property.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('project.property.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('project.property.view.title') }}</span>

        <span :class="'companyStatus companyStatus_' + project.companyStatus"></span>

        <toggle-button
          style="margin-left:20px"
          v-model="project.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{checked: 'Affiché sur le site web', unchecked: 'Masqué sur le site web'}"
        />
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>

        <form @keyup.enter="createProject">
          <div class="row">
            <div class="form-group col-md-6">
              <photo-uploader
                :compMode="compMode"
                entite="Project"
                :fileType="fileType_projectLogo"
                ref="logoUploader"
              ></photo-uploader>
            </div>
            <div class="form-group col-md-6">
              <photo-uploader
                :compMode="compMode"
                entite="Project"
                :fileType="fileType_projectImage"
                ref="imageUploader"
              ></photo-uploader>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="nameInput">{{ $t('project.form.name') }}*</label>

              <input
                maxlength="100"
                v-model.trim="project.entreprise.name"
                v-validate="'required'"
                name="name"
                type="text"
                class="form-control"
                id="nameInput"
                placeholder="Nom"
              />
              <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="description">{{ $t('project.form.description') }}</label>
              <ckeditor
                :editor="editor"
                v-model.trim="descriptionInitialize"
                name="description"
                id="description"
                :config="editorConfig"
              ></ckeditor>
            </div>
            <div class="form-group col-md-6">
              <label for="description_en">{{ $t('project.form.description') + ' (EN)' }}</label>
             <ckeditor
                        :editor="editor"
                v-model.trim="descriptionEnInitialize"
                name="description_en"
                id="description_en"
                :config="editorConfig"
              ></ckeditor>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-4">
              <label for="phoneInput">{{ $t('project.form.phone') }}*</label>
              <input
                v-model.trim="project.entreprise.phone"
                v-mask="'(###) ###-####'"
                v-validate="{ rules: { required : true , regex: phoneRegex() } }"
                name="phone"
                type="text"
                class="form-control"
                id="phoneInput"
                placeholder="(999) 999-9999"
              />
              <span class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
            </div>
            <div class="form-group col-md-4">
              <label for="faxInput">{{ $t('project.form.fax') }}</label>
              <input
                v-model.trim="project.entreprise.fax"
                v-mask="'(###) ###-####'"
                name="fax"
                type="text"
                class="form-control"
                id="faxInput"
                placeholder="(999) 999-9999"
              />
              <span class="text-danger" v-if="errors.has('fax')">{{ errors.first('fax') }}</span>
            </div>
            <div class="form-group col-md-4">
              <label for="constitutionDateInput">{{ $t('project.form.constitutionDate') }}</label>
              <input
                v-model.trim="project.constitutionDate"
                v-mask="'##/##/####'"
                v-validate="'date_format:DD/MM/YYYY'"
                name="constitutionDate"
                type="text"
                class="form-control"
                id="constitutionDateInput"
                placeholder="DD/MM/YYYY"
              />
              <span
                class="text-danger"
                v-if="errors.has('constitutionDate')"
              >{{ errors.first('constitutionDate') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="statusInput">{{ $t('project.form.status') }}*</label>
              <input
                type="hidden"
                name="projectCompanyStatus_validate"
                v-model="projectCompanyStatus_validate"
                v-validate="'required'"
              />
              <select
                v-model="project.companyStatus"
                v-validate="'required'"
                :disabled="!editable"
                :class="'form-control companyStatus_'+ project.companyStatus"
                id="statusInput"
              >
                <option
                  :class="'companyStatus_'+ s.item1"
                  v-for="s in companyStatuses"
                  :value="s.item1"
                  :key="s.item1"
                >{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('projectCompanyStatus_validate')"
              >{{ $t('validations.required') }}.</span>
            </div>

            <div class="form-group col-md-4" v-if="project.companyStatus == 0">
              <label for="inactifReasonInput">{{ $t('project.form.reasonInactif') }}*</label>
              <input
                type="hidden"
                name="projectReasonInactif_validate"
                v-model="projectReasonInactif_validate"
                v-validate="'required'"
              />
              <select
                v-model="project.reasonInactif"
                v-validate="'required'"
                :disabled="!editable"
                :class="'form-control exitReason_'+ project.reasonInactif"
                id="inactifReasonInput"
              >
                <option
                  :class="'exitReason_'+ s.item1"
                  v-for="s in reasonsInactif"
                  :value="s.item1"
                  :key="s.item1"
                >{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('projectReasonInactif_validate')"
              >{{ $t('validations.required') }}.</span>
            </div>
          </div>

  <div class="row">
                <div class="form-group col-md-4">
              <label for="sectorOfActivityInput">{{ $t('project.company.form.sectorOfActivity')  + " (ancien, obsolète et pour filtrer dans mercure seulement)" }}*</label>
              <input type="hidden" name="projectSectors_validate" v-model="projectSectors_validate" v-validate="'required'" />
              <select v-model="project.sectorOfActivity" v-validate="'required'" class="form-control" id="sectorOfActivityInput" >
                <option v-for="s in sectors" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('projectSectors_validate')">{{ $t('validations.required') }}.</span>
            </div>


                                             <div class="form-group col-md-2">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.areaOfActivities')  + " (nouveau)" }}</label>
                        <input
                        type="hidden"
                        name="sector"
                        v-model="project.sectorId"
                      />

                       <select
                        v-model="project.sectorId"
                        class="form-control"
                        id="sector"
                        @change="sectorChange"
                      >
                        <option v-for="s in newSectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>

                    <div class="form-group col-md-2" v-if="subSectors.length">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.subSector') }}</label>
                        <input
                        type="hidden"
                        name="subSector"
                        v-model="project.subSectorId"
                      />

                       <select
                        v-model="project.subSectorId"
                        class="form-control"
                        id="sector"
                      >
                        <option v-for="s in subSectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>
  </div>


           <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t('member.form.socialTitle') }}</div>
                <div class="card-body">
                  <div class="row">
                      <div class="form-group col-md-3">
                      <label for="website">{{ $t('social.websiteLink') }}</label>
                      <input
                        type="text"
                        id="website"
                        v-model.trim="project.website"
                        name="website"
                        class="form-control"
                      />
                    </div>    
                  </div>
                </div>
              </div>
            </div>
           </div>



          <address-component v-bind:address="project.entreprise.address"></address-component>

          <investmentSummary :entites="investments" v-if="compMode == CRUDMODE.READ"></investmentSummary>

          <div
            class="card font-weight-bold text-uppercase bg-warning mb-3"
            v-if="project.importedFromInvestment && compMode == CRUDMODE.UPDATE"
          >
            <div class="card-body">
              <label class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  name="lead"
                  value="1"
                  class="custom-control-input"
                  id="removeImportedFlag"
                  v-model="project.removeImportedFlag"
                />
                <span class="custom-control-indicator"></span>
                <span class="custom-control-label">{{ $t('removeImportedFlag') }}</span>
              </label>
            </div>
          </div>

          <a
            @click="createProject"
            v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
            id="addButton"
            class="btn btn-primary"
          >{{ $t('form.create_button') }}</a>

          <a
            @click="editProject"
            v-if="compMode == CRUDMODE.UPDATE"
            id="editButton"
            class="btn btn-primary"
          >{{ $t('form.edit_button') }}</a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ProjectServiceClient,
  PropertyServiceClient,
  EntrepriseServiceClient,
  CompanyServiceClient,
  InvestmentServiceClient,
  AddressDto,
  LocalizableStringDto,
  PropertyDto,
  EntrepriseDto,
  SectorServiceClient,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import AddressComponent from '../Address.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Enum from '../../shared/enum'
import InvestmentSummary from '../Investment/InvestmentSummary'
import {ToggleButton} from 'vue-js-toggle-button'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'

export default {
  name: 'CreateProjectProperty',
  mixins: [CrudMixin],
  data() {
    let dto = new PropertyDto()
    dto.displayInWebsite = true
    dto.init({projectType: 2, companyStatus: 1})
    dto.displayInWebsite = true
    dto.entreprise = this.createEntreprise({})
    dto.description = new LocalizableStringDto()

    return {
      ready: false,
      error: '',
      project: dto,
      investments: [],
      companyStatuses: [],
      editable: true,
      // deprecated
      sectors: [],
      // new sectors from db
      newSectors: [],
      subSectors: [],
      reasonsInactif: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'link',
            '|',
            'outdent',
            'indent',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'insertTable',
            '|',
            'blockQuote',
            '|',
            'undo',
            'redo',
            'removeFormat',
          ],
        },
      },
    }
  },
  computed: {
    projectSectors_validate: function() {
      return this.project.sectorOfActivity
    },
    descriptionInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.description.french == null) {
          return ' '
        }
        return this.project.description.french
      },
      // setter
      set: function(newValue) {
        this.project.description.french = newValue
      },
    },
    descriptionEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.description.english == null) {
          return ' '
        }
        return this.project.description.english
      },
      // setter
      set: function(newValue) {
        this.project.description.english = newValue
      },
    },
    projectCompanyStatus_validate: function() {
      return this.project.companyStatus
    },
    projectReasonInactif_validate: function() {
      if (this.project.companyStatus == 0) return this.project.reasonInactif
      return 'not_required'
    },
    fileType_projectLogo: function() {
      return Enum.FileType.PROJECTLOGO
    },
    fileType_projectImage: function() {
      return Enum.FileType.PROJECTIMAGE
    },
  },
  methods: {
    createProject: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let PropertyService = ServiceFactory.create(PropertyServiceClient)

            PropertyService.create(self.project)
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.logoUploader.persistPhoto(res.id)
                self.$refs.imageUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('project.property.create.succes'), 'success')
                this.$router.push({path: '/projects'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editProject: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let propertyService = ServiceFactory.create(PropertyServiceClient)

            propertyService
              .update(self.cleanFields(self.project))
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.logoUploader.persistPhoto(self.$route.params.id)
                self.$refs.imageUploader.persistPhoto(self.$route.params.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('project.property.edit.succes'), 'success')
                this.$router.push({path: '/projects'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    sectorChange: function() {
      let self = this
      let sectorService = ServiceFactory.create(SectorServiceClient)
      let getSubSectors = sectorService.getSubSector(this.project.sectorId)

      getSubSectors
        .then(res => {
          self.subSectors = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let service = ServiceFactory.create(ProjectServiceClient)
      let companyService = ServiceFactory.create(CompanyServiceClient)
      let propertyService = ServiceFactory.create(PropertyServiceClient)
      let sectorService = ServiceFactory.create(SectorServiceClient)
      let getCompanyStatus = service.getCompanyStatus()
      let getCompanySector = companyService.getSectorOfActivity()
      let getReasonInactif = service.getReasonInactif()

      let getSectors = sectorService.getSectors()
      let self = this
      let promisseAll

      getCompanyStatus
        .then(res => {
          self.companyStatuses = res
        })
        .catch(err => {
          console.log(err)
        })
      getReasonInactif
        .then(res => {
          self.reasonsInactif = res
        })
        .catch(err => {
          console.log(err)
        })
      getSectors
        .then(res => {
          self.newSectors = res
        })
        .catch(err => {
          console.log(err)
        })
      getCompanySector
        .then(res => {
          self.sectors = res
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let getProject = propertyService.get(this.$route.params.id)
        getProject
          .then(res => {
            self.project = res

            if (res.sectorId != null) {
              let getSubSectors = sectorService.getSubSector(res.sectorId)
              getSubSectors
                .then(res => {
                  self.subSectors = res
                })
                .catch(err => {
                  console.log(err)
                })
            }

            self.multiSelectEntreprise = res.entreprise

            if (self.project.constitutionDate != undefined) {
              self.project.constitutionDate = self.$options.filters.formatDate(self.project.constitutionDate)
            }

            if (self.compMode == Enum.Mode.READ) {
              self.chargerInvestments(self.project.id)
            }

            if (self.project.companyStatus == 0 && self.project.reasonInactif != 5) {
              // Commented just for the first phase of the project to correct bad data
              //this.editable = false
            }

            self.checkCopyMode(self.project)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getCompanyStatus, getReasonInactif, getProject])
      } else {
        promisseAll = Promise.all([getCompanyStatus, getReasonInactif])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
    createEntreprise: function(entrepriseInit) {
      let entreprise = new EntrepriseDto()
      entreprise.init(entrepriseInit)
      entreprise.address = new AddressDto()
      entreprise.address.init({})

      return entreprise
    },
    chargerInvestments: function(id) {
      let InvestmentService = ServiceFactory.create(InvestmentServiceClient)
      let self = this

      InvestmentService.getAll(id, undefined, '', 0, 10000)
        .then(res => {
          self.investments = res.items
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
  components: {
    errorMessage: ErrorMessage,
    AddressComponent: AddressComponent,
    multiselect: Multiselect,
    InvestmentSummary,
    ToggleButton,
    'photo-uploader': PhotoUploader,
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/CreateProperty.vue